import { useState, useEffect } from "react";
import { db } from "./firebase.js";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import { RiTa, RiMarkov } from 'rita'; 



const HIGHLIGHT_MAP = {
 culture: "45% spoke about preserving cultural identity",
 ai: "41% mentioned AI ethics and governance",
 justice: "33% mentioned justice and fairness",
 equity: "28% asked for equity in technology",
 borders: "19% discussed cross-border collaboration",
 blend: "22% highlighted multicultural integration",
 love: "17% expressed values around love and humanity",
 ethics: "26% emphasized the need for ethical frameworks"
};


function highlightLine(line, glossaryEntries = []) {
  const glossaryMap = glossaryEntries.reduce((acc, entry) => {
    if (entry.word && entry.meaning) {
      acc[entry.word.toLowerCase()] = entry.meaning;
    }
    return acc;
  }, {});

  const tokens = line.split(/\b/); // splits by word boundaries

  return tokens.map((token, i) => {
    const cleaned = token.toLowerCase().replace(/[^\w]/g, "");
    const meaning = glossaryMap[cleaned];
    if (meaning) {
      return (
        <span key={i} style={{ backgroundColor: '#013220', cursor: 'help' }} title={meaning}>
          {token}
        </span>
      );
    }
    return <span key={i}>{token}</span>;
  });
}



function generateLine2(corpusText, glossaryList = [], maxTries = 100) {
  const untranslatableWords = glossaryList.length > 0
    ? glossaryList.join(" | ")
    : "ajrak | Tachiyomi | Abendrot | Petrichor"; 

  const rules = {
   "start": "$negativeEmotion of losing $misunderstood, $untranslatable",
   "negativeEmotion": "Sadness | Fear | Unease | Anxiousness | Worry",
   "untranslatable" : untranslatableWords,
   "conj": "of | to be",
   "misunderstood": "societal interactions| traditions | customs | signs | words | communities | grammar | culture | history | universal | context | caste | social hierarchy | informal language | taboos | regional | norms | perspectives | family structures | values| poverty | drug trafficking | factions | money | religious beliefs | cultural sensitivity | misinterpretation | language barriers | uniqueness | geographies | body language | race| peculiarities"
 } 
 const grammar = RiTa.grammar(rules);
 const result = grammar.expand();


 return result;
}


function generateLine4(corpusText, targetWord, maxTries = 100) {
  const rules = {
   "start": "$trait $conj $trustworthy",
   "trait": "collective spirit | cooperation | helping | exchange | hospitable | respect | people | behaviour | kindness | embrace | kinship | ties | generosity | acceptance | nourishment",
   "conj": "defined by | in search of",
   "trustworthy": "honest | reliable | experienced | straightforward | impactful | listener | accurate | thoughtful"
 } 
 const grammar = RiTa.grammar(rules);
 const result = grammar.expand();


 return result;
}


async function callOpenAI(prompt) {
 try {
   const response = await fetch("/.netlify/functions/openai", {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
     },
     body: JSON.stringify({
      messages: [{ role: "user", content: prompt }],
    })    
   });


   const data = await response.json();
   console.log("Full OpenAI response:", data);




   if (!data.choices || !data.choices[0] || !data.choices[0].message) {
     console.error("Invalid OpenAI response:", data);
     return "(AI generation failed)";
   }


   return data.choices[0].message.content.trim();
 } catch (err) {
   console.error("OpenAI Error:", err);
   return "(error generating line)";
 }
}




export default function LimerickExperience() {
 const [corpus, setCorpus] = useState("");
 const [stage, setStage] = useState(0);
 const [mode, setMode] = useState("user"); // 'user' or 'random'
 const [userInput1, setUserInput1] = useState("");
 const [userInput2, setUserInput2] = useState("");
 const [lines, setLines] = useState(["If words were enough, I would whisper-- ", "", "", "", ""]);
 const [loading, setLoading] = useState(false);
 const [glossaryWords, setGlossaryWords] = useState([]);
 const [userInputStarted, setUserInputStarted] = useState(false);


useEffect(() => {
  const fetchGlossary = async () => {
    try {
      const snapshot = await getDocs(collection(db, "glossary"));
      const entries = snapshot.docs
        .map(doc => doc.data())
        .filter(entry => entry.word && entry.meaning);
      setGlossaryWords(entries);
    } catch (err) {
      console.error("Failed to fetch glossary words:", err);
    }
  };

  fetchGlossary();
}, []);

 useEffect(() => {
   fetch("/corpus.txt")
     .then(res => res.text())
     .then(setCorpus)
     .catch(err => console.error("Failed to load corpus:", err));
 }, []);


 const runRandomPoem = async () => {
  const glossaryTerms = Array.isArray(glossaryWords)
  ? glossaryWords.map(entry => entry.word)
  : [];
   setLoading(true);
   const updated = [...lines];
   updated[0] = "If words were enough, I would whisper-- ";
   updated[1] = generateLine2(corpus, glossaryTerms);
   const target1 = updated[1].trim().split(/\s+/).pop().replace(/[^\w]/g, '');
   updated[2] = await callOpenAI(`Write a poetic line with 9 words or fewer that rhymes with "${target1}". It should respond to: "${updated[1]}" and reflect cultural nuance, ambiguity, or hidden meaning. Keep it lyrical and resonant.`);
   updated[3] = generateLine4(corpus);
   const target2 = updated[3].trim().split(/\s+/).pop().replace(/[^\w]/g, '');
   updated[4] = await callOpenAI(`Write a poetic line with 9 words or fewer that rhymes with "${target2}". It should respond to: "${updated[3]}" and reflect cultural nuance, ambiguity, or hidden meaning. Keep it lyrical and resonant.`);


   setLines(updated);
   setStage(2);
   setLoading(false);

   try {
    await addDoc(collection(db, "limericks"), {
      lines: updated,
      createdAt: new Date()
    });
  } catch (error) {
    console.error("Error saving to Firestore:", error);
  }
 };


 const handleFirstSubmit = async () => {
   const updated = [...lines];
   updated[1] = userInput1;
   const target = updated[1].trim().split(/\s+/).pop().replace(/[^\w]/g, '');
   const prompt = `Write a poetic line with 9 words or fewer that rhymes with "${target}". It should respond to: "${userInput1}" and reflect cultural nuance, ambiguity, or hidden meaning. Keep it lyrical and resonant.`;
   updated[2] = await callOpenAI(prompt);
   console.log("did an openai call");
   setLines(updated);
   setStage(1);


  //  try {
  //    await addDoc(collection(db, "limericks"), {
  //      lines: updated,
  //      createdAt: new Date()
  //    });
  //  } catch (error) {
  //    console.error("Error saving to Firestore:", error);
  //  }
 };


 const handleSecondSubmit = async () => {
   const updated = [...lines];
   updated[3] = userInput2;
   const target = updated[3].trim().split(/\s+/).pop().replace(/[^\w]/g, '');
   const prompt = `Write a poetic line with 9 words or fewer that rhymes with "${target}". It should respond to: "${userInput2}" and reflect cultural nuance, ambiguity, or hidden meaning. Keep it lyrical and resonant.`;
   updated[4] = await callOpenAI(prompt);
   console.log("did an openai call");
  
   setLines(updated);
   setStage(2);


   try {
     await addDoc(collection(db, "limericks"), {
       lines: updated,
       createdAt: new Date()
     });
   } catch (error) {
     console.error("Error saving to Firestore:", error);
   }
 };


 return (
    <div className="container" style={{ padding: '2rem', margin: '0 auto' }}>
      <div style={{ padding: '2rem', margin: '0 auto' }}>
     <Link to="/">Home</Link> | <Link to="/explore"> Archive </Link> | <Link to="/glossary"> Whispered Footnotes </Link> | <Link to="/about">About</Link>



     {stage === 0 && (
       <div>
         <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>If words were enough</h1>
         <div className="section">
           <p>As AI systems learn from us, they also erase parts of us. Language isn’t just information—it’s memory, emotion, context, and care. </p>
           <p>This is a poetic memory generator that invites people to build a limerick together with AI. </p>
           <p></p>
           <p style={{}}> <strong> Write or generate one: </strong> </p>
           <ul style={{fontSize: '0.9rem'}}>
            <li>The first sentence is the same for all. Guiding prompts are available.</li>
            <li>Write your own. You contribute your lines. The AI responds. Together, you build a 5-line poem that becomes a trace of language that matters to you and what shouldn’t be forgotten. </li>
            <li>Prefer not to write? The poem will speak from elsewhere—drawing on sentence templates shaped by global responses, echoing emotional cues, misunderstood words, and the traits people turn to for meaning. </li>
           </ul>
           <p> Each poem is a miniature policy in disguise. </p> 
           <p> Sometimes you have magic. Sometimes the poem doesn’t work. AI stutters when it hears what it hasn’t been trained to listen for. </p>
           <p> The final suggestions gesture at what the future needs to preserve.</p>
         </div>
         <div style={{marginTop: '1rem', marginBottom: '1.5rem' }}>
           <button
             onClick={() => setMode("user")}
             style={{ marginRight: '1rem', padding: '0.5rem 1rem', backgroundColor: mode === "user" ? '#4f46e5' : '#e5e7eb', color: mode === "user" ? 'white' : 'black', border: 'none', borderRadius: '0.375rem' }}
           >
             Make your own
           </button>
           <button
             onClick={() => setMode("random")}
             style={{ padding: '0.5rem 1rem', backgroundColor: mode === "random" ? '#4f46e5' : '#e5e7eb', color: mode === "random" ? 'white' : 'black', border: 'none', borderRadius: '0.375rem' }}
           >
             Generate random
           </button>
         </div>


         {mode === "user" ? (
            <>
              <div className="prompt-box"> 
              <p><em>Consider this, if it helps:</em></p>
              <p> What do you say when no one’s listening? </p>
              <p> Is there a word that you think AI doesn't know, unique to your culture?</p>
              </div>
              <label style={{ display: 'block', marginTop: '1rem' }}>

                <p className="poem-box"> If words were enough, I would whisper -- </p>
                <textarea
                  rows={3}
                  style={{ width: '100%', padding: '0.5rem' }}
                  value={userInput1}
                  onChange={(e) => setUserInput1(e.target.value)}
                />
              </label>
              <button
                onClick={handleFirstSubmit}
                style={{ marginTop: '1rem', padding: '0.5rem 1rem', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '0.375rem' }}
              >
                Next
              </button>
            </>
          ) : (
            <button
              onClick={runRandomPoem}
              disabled={loading}
              style={{ padding: '0.75rem 1.5rem', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '0.5rem' }}
            >
              {loading ? "Generating..." : "Go"}
            </button>
          )}
        </div>
      )}


     {stage === 1 && (
       <div>
         <div className="poem-box">
          <h2>{lines[0]}</h2>
          <p>{lines[1]}</p>
          <p>{lines[2]}</p>
        </div>
         <label style={{ display: 'block', marginTop: '1rem' }}>
          
         <div className="prompt-box"> 
              <p><em>Consider this, if it helps:</em></p>
              <p>What metaphors, meanings, or memories get lost when language becomes generic?</p>
              <p>Is there a word from your family or culture that doesn’t quite translate?</p>
              </div>
           
           <textarea
             rows={3}
             style={{ width: '100%', padding: '0.5rem' }}
             value={userInput2}
             onChange={(e) => setUserInput2(e.target.value)}
           />
         </label>
         <button
           onClick={handleSecondSubmit}
           style={{ marginTop: '1rem', padding: '0.5rem 1rem', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '0.375rem' }}
         >
           Show Final Poem
         </button>
       </div>
     )}


     {stage === 2 && (
       <div>
         <div className="poem-box">
           {lines.map((line, i) => (
             <p key={i}>{highlightLine(line, glossaryWords)}</p>
           ))}
         </div>
         <div style={{ marginTop: '1.5rem' }}>
           <Link to="/explore" style={{ marginRight: '1rem' }}>Explore the Archive</Link>
           <Link to="/glossary">Add your words to the Footnotes</Link>
         </div>
         <button
          onClick={() => {
            setStage(0);
            setUserInput1("");
            setUserInput2("");

            setLines(["If words were enough, I would whisper-- ", "", "", "", ""]);
            setMode("user"); 
          }}
          style={{ marginTop: '1.5rem', padding: '0.5rem 1rem', backgroundColor: '#f87171', color: 'white', border: 'none', borderRadius: '0.375rem' }}
        >
          Start Over
        </button>
       </div>
     )}
   </div>
   </div>
 );
}